import React from 'react';
import classNames from 'classnames';
import css from './spacer.module.scss';

type Props = {
  size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  grow?: boolean;
};

const Spacer: React.FC<Props> = ({ size = 1, grow = false }) => (
  <div
    className={classNames(css.root, css[`size-${size}`], grow && css.grow)}
  />
);

export default Spacer;
